module.exports = __webpack_public_path__ + "assets/img/WechatIMG53.a356266f.png";